module.exports = __webpack_public_path__ + "static/005-ecfcba7e76bd5419d394cbb5f0dcb741.jpg";